module.exports = __webpack_public_path__ + "static/media/img-download-center4.bce81b99.png";